import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import LoadingContainer from './LoadingContainer';
import Card from './Card';
import './AutocompleteOptions.scss';
var OPTION_SIZES = {
    SMALL: 'small',
    MEDIUM: 'medium',
    LARGE: 'large',
    FULL: 'full'
};
var AutocompleteOptions = function (_a) {
    var focusIndex = _a.focusIndex, formatOption = _a.formatOption, isLoading = _a.isLoading, minQueryLength = _a.minQueryLength, noResultsText = _a.noResultsText, onHover = _a.onHover, onSelect = _a.onSelect, optionWidth = _a.optionWidth, options = _a.options, query = _a.query;
    var _b = useState(false), isAnimating = _b[0], setIsAnimating = _b[1];
    var _c = useState(0), prevQueryLength = _c[0], setPrevQueryLength = _c[1];
    useEffect(function () {
        var _a;
        if (query) {
            if ((query.length >= minQueryLength && prevQueryLength < minQueryLength) ||
                (query.length < minQueryLength && prevQueryLength >= minQueryLength)) {
                setIsAnimating(true);
            }
        }
        setPrevQueryLength((_a = query === null || query === void 0 ? void 0 : query.length) !== null && _a !== void 0 ? _a : 0);
        return function () {
            setPrevQueryLength(0);
        };
    }, [isAnimating, minQueryLength, prevQueryLength, query, setPrevQueryLength]);
    var containerClass = classNames('AutocompleteOptions', "AutocompleteOptions--".concat(optionWidth, "Width"), 'u-padding-n', {
        'AutocompleteOptions--isAnimating': isAnimating,
        'AutocompleteOptions--isOpen': prevQueryLength >= minQueryLength
    });
    return (React.createElement(Card, { className: containerClass, isCentered: false, onAnimationEnd: function () { return setIsAnimating(false); }, type: 'white' },
        React.createElement(LoadingContainer, { isLoading: Boolean(isLoading) }, options && options.length ? (React.createElement("ul", { className: 'AutocompleteOptions__list', role: 'listbox' }, options.map(function (option, index) {
            var optionClasss = classNames('AutocompleteOptions__option', {
                'AutocompleteOptions__option--isActive': focusIndex === index
            });
            return (React.createElement("li", { className: optionClasss, "data-testid": "AutocompleteOption-".concat(option.id), key: option.id, onClickCapture: function () { return onSelect(options[index]); }, onMouseEnter: function () { return onHover(index); } }, formatOption(option, query)));
        }))) : (React.createElement("div", { className: 'u-padding-32 u-marginLeft-4' }, noResultsText)))));
};
AutocompleteOptions.defaultProps = {
    isLoading: true,
    optionWidth: OPTION_SIZES.FULL
};
AutocompleteOptions.propTypes = {
    focusIndex: PropTypes.number.isRequired,
    formatOption: PropTypes.func.isRequired,
    isLoading: PropTypes.bool,
    minQueryLength: PropTypes.number.isRequired,
    noResultsText: PropTypes.string.isRequired,
    onHover: PropTypes.func.isRequired,
    onSelect: PropTypes.func.isRequired,
    optionWidth: PropTypes.oneOf(Object.values(OPTION_SIZES)),
    options: PropTypes.arrayOf(PropTypes.shape({ id: PropTypes.number.isRequired }).isRequired),
    query: PropTypes.string
};
export default AutocompleteOptions;
//# sourceMappingURL=AutocompleteOptions.js.map